export default __webpack_public_path__ + "static/media/avatar_102.78ac73a9.png";